import { render, staticRenderFns } from "./product-offer-modal.vue?vue&type=template&id=bf12b332&scoped=true&"
import script from "./product-offer-modal.vue?vue&type=script&lang=js&"
export * from "./product-offer-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf12b332",
  null
  
)

export default component.exports